import React from 'react';
import Sidebar from '../components/admin/Sidebar';

const DashboardLayout = ({children}) => {
  return (
    <div>
      <div className="wrapper d-flex min-vh-100">
        <Sidebar />
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;